import { css } from '@emotion/core';
import { rgba, variables } from '@domain-group/fe-brary';
var colour = variables.colour,
  global = variables.global;
export var container = {
  name: "79elbk",
  styles: "position:relative;"
};
export var image = {
  name: "sfjdjv",
  styles: "width:100%;cursor:pointer;"
};
export var imageContainer = {
  name: "79elbk",
  styles: "position:relative;"
};
export var fullScreenIconContainer = /*#__PURE__*/css("display:inline-block;padding:5px;position:absolute;bottom:20px;left:10px;z-index:", global.layerOverlay, ";pointer-events:none;background-color:", rgba(colour.neutral700, 0.6), ";border-radius:100%;");
export var fullScreenIcon = /*#__PURE__*/css("color:", colour.neutral100, ";");